import { useEffect, useState } from 'react';
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import { Pagination, PaginationItem, Stack } from '@stitch-fix/mode-react';
import { usePaginationParams } from '../../utils/hooks/usePaginationParams';
interface PaginationLinksProps {
  /**
   * The `pageCount` value returned by the items query,
   * indicating the total number of item pages available.
   */
  pageCount: number;
  buttonGroupLabel?: string;
  scrollToId?: string;
}

/**
 * The `PaginationLinks` component is a wrapper around mode-react's `Pagination` component.
 * It implements Next's `Link` component to render the pagination links and prevent
 * full page refreshes when navigating between pages.
 */
const PaginationLinks = ({
  buttonGroupLabel = 'Pagination navigation',
  pageCount,
  scrollToId
}: PaginationLinksProps) => {
  const {
    paginationParams,
    getPageLinkParams
  } = usePaginationParams();
  // Do not add top margin when the pageCount is 1 since `<Pagination>` renders null
  const topMargin = pageCount > 1 ? 2 : 0;
  const router = useRouter();
  const [shouldScroll, setShouldScroll] = useState(false);
  useEffect(() => {
    if (!scrollToId || !shouldScroll) return;
    const el = document.getElementById(scrollToId);
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }

    // Reset scroll flag after scrolling
    setShouldScroll(false);
  }, [router.asPath, scrollToId, shouldScroll]);
  return <Stack spacing={0} hAlign="center" mt={topMargin}>
      <Pagination aria-label={buttonGroupLabel} total={pageCount} value={paginationParams.page} renderItem={item => <NextLink href={{
      query: getPageLinkParams(item.page)
    }} scroll={!scrollToId} shallow passHref legacyBehavior>
            <PaginationItem {...item} as="a" onClick={() => setShouldScroll(true)} />
          </NextLink>} />
    </Stack>;
};
export default PaginationLinks;